import { render, staticRenderFns } from "./browser-other.vue?vue&type=template&id=81641b3e"
import script from "./browser-other.vue?vue&type=script&lang=js"
export * from "./browser-other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports